import CustomFieldStatus from "enums/CustomFieldStatus";
import CustomFieldType from "enums/CustomFieldType";
import { SimplifiedCustomField } from "./customFields.types";

// Empty for *display* purposes: a checkbox is empty unless explicitly
// checked, other types are empty when every entry is blank/whitespace.
// Used by visibility filtering for READONLY fields where rendering an empty
// row is meaningless.
//
// Note: this is intentionally different from "the user has interacted with
// this field" — an unchecked checkbox (["false"]) is empty for display but
// counts as interaction for required-field validation.
export function isCustomFieldValueEmpty(
  field: SimplifiedCustomField,
  values: string[],
): boolean {
  if (field.type === CustomFieldType.CHECKBOX) {
    return values[0] !== "true";
  }
  return values.every((value) => value == null || String(value).trim() === "");
}

// True when the field should render on a live form. DISABLED is always
// hidden; READONLY hides when empty so we don't surface meaningless rows.
export function isCustomFieldVisible(
  field: SimplifiedCustomField,
  values: string[],
): boolean {
  if (field.status === CustomFieldStatus.DISABLED) return false;
  if (field.status === CustomFieldStatus.READONLY) {
    return !isCustomFieldValueEmpty(field, values);
  }
  return true;
}

// Checkbox value sentinels.
export function isCheckboxChecked(values: string[]): boolean {
  return values[0] === "true";
}

export function toCheckboxValue(checked: boolean): string {
  return checked ? "true" : "false";
}
